import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import {
  NewBackButton,
  NoticeIcon,
  TrophyIcon,
} from "../../../../components/svgs";
import { Button, StyledText } from "../../../../components/common/basic";

// theme

import spaceMan from "../../../../components/images/spaceMan.png";
import { useTheme } from "../../../../hooks";

const GameStatusScreen = () => {
  let history = useHistory();
  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  const { themeContext, theme } = useTheme();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const hasWon = true;
  const amountWon = 10;

  return (
    <MainHolder>
      <Children>
        <div
          style={{
            width: "90%",
            display: "flex",
            alignItems: "center",
            width: "95%",
            justifyContent: "space-between",
          }}
        >
          <BackButtonContainer
            onClick={() => goToHome()}
            style={{ zIndex: 100 }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <StyledText style={{ fontSize: 24 }}>Fastest Finger</StyledText>
          <NoticeIcon
            fill="black"
            style={{ zIndex: 100 }}
            onClick={() => history.push("/fastest_finger/fastest_finger_tips")}
          />
        </div>

        <DescriptionBody color={mashupBackground}>
          <StyledText style={{ fontFamily: "MTNRegular", marginBottom: 30 }}>
            Fastest finger has ended
          </StyledText>
          <img width={"80%"} src={spaceMan} alt="spaceMana" />
          <StyledText color="white">Ok</StyledText>
          <div style={{ marginTop: 20, marginBottom: 30 }}>
            {hasWon ? (
              <StyledText
                style={{ fontFamily: "MTNRegular", textAlign: "center" }}
              >
                <span style={{ fontFamily: "MTNBold" }}>
                  Thanks for participating!
                </span>{" "}
                Come back next time and stand a chance to win again!
              </StyledText>
            ) : (
              <StyledText
                style={{ fontFamily: "MTNRegular", textAlign: "center" }}
              >
                Unfortunately you were not among the 20 winners. Come back next
                time and stand a chance to win!
              </StyledText>
            )}
          </div>
          <Button onClick={goToHome} style={{ backgroundColor: background, width: "80%" }}>
            <StyledText color="white">Ok</StyledText>
          </Button>
        </DescriptionBody>
      </Children>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  padding-inline: 20px;
`;

export default GameStatusScreen;
